export default "__VITE_ASSET__BwmUtUc7__"